// UserComponent.js
import React, { useEffect, useState } from 'react';
import logo from '../images/kalingarayanrunners_logo.svg';
import { useRecoilState, useRecoilValue } from 'recoil';
import { Link , useNavigate, useParams} from 'react-router-dom';
import { ActiveEvents, pageDetails } from '../Recoil/ActiveEvents';
import ContactPopup from '../Components/Popup';

function Header() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(null);
  const [currentIndex,setCurrentIndex] = useState(0);
  const [activeEvents, setActiveEvents] = useRecoilState(ActiveEvents);
  const [currIndex, setCurrIndex] = useRecoilState(pageDetails);
  const [imageURI , setImageURI] = useState('');
  const updateBoollen = (value) => {
    setIsOpen(value);
  }
  const { id } = useParams();
  
  useEffect(() => {
    let imageURL = activeEvents[currIndex.currentIndex];
    imageURL = !!imageURL ? imageURL.ImgUrl :'';
    let encodedUrl = "";
    let isDirect = true;
    if(!!imageURL && imageURL != ''){
      isDirect = false;
      const [protocol, path] = imageURL.split("://");
      const encodedPath = path
        .split("/")
        .map(segment => encodeURIComponent(segment)) 
        .join("/");
      encodedUrl = `${protocol}://${encodedPath}`;
      setImageURI(encodedUrl);
    }else if(!!id){
      isDirect = false;
      let eventURI = process.env.REACT_APP_API_URL +"/Events/GetEventDetails";
      fetch(eventURI ,  {
        method: "POST",
        body: JSON.stringify(id),
        headers: {"Content-Type": "application/json"}})
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((result) =>{
        setActiveEvents(result.Events)
        let imageURI = !!result && result.Events.length > 0 && !!result.Events[0].ImgUrl ?  result.Events[0].ImgUrl : ''
        setImageURI(imageURI)
      }
      )
      .catch((error) => console.error(error));
      }
      if(!!isDirect) {
        navigate('/')
      }
    }, []);
  return (
    <div>
          <ContactPopup popup={isOpen} updateValue={(value)=>updateBoollen(value)}/>
          {/* <div className="relative w-full h-screen overflow-hidden"> */}
          {/* <div  className="relative bg-cover bg-center pb-[60vh]"
      style={{ backgroundImage: `url(${imageURI})` }}>
             <header className="relative p-4 fixed top-0 left-0 z-[3] bg-orange-500 bg-opacity-20">
              <div className="container mx-auto flex justify-between items-center"> */}
              <div className="w-full relative bg-cover bg-center  pb-[60vh]" style={{ backgroundImage: `url(${imageURI})` }}>
                <header className="relative p-4 fixed top-0 left-0 z-[3] bg-orange-500 bg-opacity-20 w-full">
                    <div className="container mx-auto flex justify-between items-center w-full">
                  <div className="text-2xl font-semibold">
                    <Link to="/"> <img 
                          src= {logo} 
                          alt="Logo" 
                          className="sm:max-w-[14rem] max-w-[12rem] " 
                      /></Link>
                  </div>
                  <nav>
                      <ul className="flex">
                          {/* <li><Link to="/registration" className="text-sm text-white"><button className='bg-red-600 w-28 h-10 rounded-l-lg'>Register</button></Link></li> */}
                          <li><button className='text-sm text-white bg-emerald-600 w-28 h-10 rounded' onClick={()=>updateBoollen(true)}>Contact Us</button></li> 
                      </ul>
                  </nav>
              </div>
          </header>
          </div>
        {/* <div  className="relative h-screen w-full bg-cover bg-center mt-[-0px]"
        style={{ backgroundImage: `url(${'https://images.unsplash.com/photo-1731902062588-4dce45ccc0cb?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'})` }}>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center text-white">
          </div>
        </div> */}
      </div>
  );
}

export default Header;
